import React from 'react';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHead from "@/components/PageHead";

const TermsPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead title="Terms of Service" />
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
          <div className="prose prose-slate max-w-none">
            <p className="mb-4">Last updated: April 22, 2025</p>
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Agreement to Terms</h2>
            <p className="mb-4">
              By accessing and using visanow.io, you agree to be bound by these Terms and Conditions. 
              If you disagree with any part of these terms, you may not access the website.
            </p>
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Use License</h2>
            <p className="mb-4">
              Permission is granted to temporarily access the materials on visanow.io for personal, 
              non-commercial purposes. This is the grant of a license, not a transfer of title.
            </p>
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Disclaimer</h2>
            <p className="mb-4">
              The materials on visanow.io are provided on an 'as is' basis. visanow.io makes no 
              warranties, expressed or implied, and hereby disclaims and negates all other warranties.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
